import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchCompanyPickupAddress({ payload }) {
  try {
    const res = yield call(APIS.fetchPickupAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyPickupAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyPickupAddressFailure(err?.response?.data));
  }
}
export function* handleFetchTotalPickupAddresses({ payload }) {
  try {
    const res = yield call(APIS.fetchPickupAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchTotalPickupAddressesSuccess(data));
  } catch (err) {
    yield put(actions.fetchTotalPickupAddressesFailure(err?.response?.data));
  }
}
export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleAddPickupAddress({ payload }) {
  try {
    const res = yield call(APIS.addAddress, payload);
    const { data } = res;
    yield put(actions.addPickupAddressSuccess(data));
    if (payload.onSuccess) payload.onSuccess();
  } catch (err) {
    yield put(actions.addPickupAddressFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleUpdatePickupAddress({ payload }) {
  try {
    const res = yield call(APIS.updateAddress, payload);
    const { data } = res;
    yield put(actions.updatePickupAddressSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.updatePickupAddressFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */

export function* companyPickupAddressSaga() {
  yield takeLatest(
    actions.fetchCompanyPickupAddress.type,
    handleFetchCompanyPickupAddress
  );
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(actions.addPickupAddress.type, handleAddPickupAddress);
  yield takeLatest(actions.updatePickupAddress.type, handleUpdatePickupAddress);
  yield takeLatest(
    actions.fetchTotalPickupAddresses,
    handleFetchTotalPickupAddresses
  );
}
